var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state)?_c('div',{staticClass:"text-center loading"},[_c('v-progress-circular',{attrs:{"width":3,"color":_vm.color,"indeterminate":""}})],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }